import '@rainbow-me/rainbowkit/styles.css';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { mainnet, polygon, optimism, arbitrum, base } from 'wagmi/chains';
import { http } from 'wagmi';

// Initialize the RainbowKit / Wagmi configuration
// We are using public RPC endpoints (http()) which are completely free.
export const web3Config = getDefaultConfig({
  appName: 'FinAI',
  projectId: '21fef48091f12692cad574a6f7753643', // Valid test WalletConnect Project ID for dev
  chains: [mainnet, polygon, optimism, arbitrum, base],
  transports: {
    [mainnet.id]: http(),
    [polygon.id]: http(),
    [optimism.id]: http(),
    [arbitrum.id]: http(),
    [base.id]: http(),
  },
});
